import new_axios_instance from '../../axios_instance';

/**
 * Chiamate verso l'editor del database MongoDB integrato (/v1/dbeditor/*), riservato ai due
 * operatori abilitati lato server (controllo per codice fiscale, indipendente dal ruolo).
 * Ritornano direttamente la Promise axios: la gestione del risultato avviene nel container.
 */

export const listCollections = () => new_axios_instance.get('/v1/dbeditor/collections');

export const creaCollezione = (collection) =>
    new_axios_instance.post('/v1/dbeditor/collections', {collection});

export const eliminaCollezione = (collection) =>
    new_axios_instance.delete(`/v1/dbeditor/collections/${encodeURIComponent(collection)}`);

export const elencaIndici = (collection) =>
    new_axios_instance.get(`/v1/dbeditor/collections/${encodeURIComponent(collection)}/indexes`);

export const eseguiQuery = ({collection, filter, projection, sort, limit, skip, txId}) =>
    new_axios_instance.post('/v1/dbeditor/query', {collection, filter, projection, sort, limit, skip, txId});

export const contaDocumenti = ({collection, filter, txId}) =>
    new_axios_instance.post('/v1/dbeditor/count', {collection, filter, txId});

export const eseguiAggregazione = ({collection, pipeline, txId}) =>
    new_axios_instance.post('/v1/dbeditor/aggregate', {collection, pipeline, txId});

export const inserisciDocumento = (collection, documento, txId) =>
    new_axios_instance.post(`/v1/dbeditor/document/${encodeURIComponent(collection)}`, documento, {
        params: txId ? {txId} : {}
    });

export const sostituisciDocumento = (collection, documento, txId) =>
    new_axios_instance.put(`/v1/dbeditor/document/${encodeURIComponent(collection)}`, documento, {
        params: txId ? {txId} : {}
    });

export const elimina = ({collection, filter, many, txId}) =>
    new_axios_instance.post('/v1/dbeditor/delete', {collection, filter, many, txId});

export const esporta = ({collection, filter}) =>
    new_axios_instance.post('/v1/dbeditor/export', {collection, filter});

export const iniziaTransazione = () => new_axios_instance.post('/v1/dbeditor/transaction/begin');

export const confermaTransazione = (txId) =>
    new_axios_instance.post(`/v1/dbeditor/transaction/${encodeURIComponent(txId)}/commit`);

export const annullaTransazione = (txId) =>
    new_axios_instance.post(`/v1/dbeditor/transaction/${encodeURIComponent(txId)}/abort`);

export const elencaQuerySalvate = () => new_axios_instance.get('/v1/dbeditor/savedqueries');

export const salvaQuery = ({nome, collection, tipo, query}) =>
    new_axios_instance.post('/v1/dbeditor/savedqueries', {nome, collection, tipo, query});

export const eliminaQuerySalvata = (id) =>
    new_axios_instance.delete(`/v1/dbeditor/savedqueries/${encodeURIComponent(id)}`);
